export const SET_FAQ = 'FAQ/SET_FAQ'
export const SET_FAQS = 'FAQ/SET_FAQS'
